import { AuditItemStatus, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Audit Item Status|`;

type SharedKeys = Pick<
	LocDef,
	'type' | 'portal' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type SPAuditItemStatusLocs =
	| `SPAuditItemStatusEnumInvalid`
	| `SPAuditItemStatusEnumPending`
	| `SPAuditItemStatusEnumValid`;

export const spAuditItemStatusEnumLocs: LocDefs<SPAuditItemStatusLocs> = {
	SPAuditItemStatusEnumInvalid: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}${AuditItemStatus.Invalid}`,
		description: `Audit item status: Invalid`,
		...sharedSpLocData,
		portal: 'SP',
	},
	SPAuditItemStatusEnumPending: {
		defaultValue: 'Pending',
		displayPath: `${dpRoot}${AuditItemStatus.Pending}`,
		description: `Audit item status: Pending`,
		...sharedSpLocData,
		portal: 'SP',
	},
	SPAuditItemStatusEnumValid: {
		defaultValue: 'Valid',
		displayPath: `${dpRoot}${AuditItemStatus.Valid}`,
		description: `Audit item status: Valid`,
		legacyName: 'Exam.Authorization/System.Enum.AuthPackageState.Valid',
		...sharedSpLocData,
		portal: 'SP',
	},
};

export type CPAuditItemStatusLocs =
	| `CPAuditItemStatusEnumInvalid`
	| `CPAuditItemStatusEnumPending`
	| `CPAuditItemStatusEnumValid`;

export const cpAuditItemStatusEnumLocs: LocDefs<CPAuditItemStatusLocs> = {
	CPAuditItemStatusEnumInvalid: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}${AuditItemStatus.Invalid}`,
		description: `Audit item status: Invalid`,
		...sharedCpLocData,
	},
	CPAuditItemStatusEnumPending: {
		defaultValue: 'Pending',
		displayPath: `${dpRoot}${AuditItemStatus.Pending}`,
		description: `Audit item status: Pending`,
		...sharedCpLocData,
	},
	CPAuditItemStatusEnumValid: {
		defaultValue: 'Valid',
		displayPath: `${dpRoot}${AuditItemStatus.Valid}`,
		description: `Audit item status: Valid`,
		...sharedCpLocData,
	},
};

export type SPAuditItemStatusEnumLocType = LocMap<SPAuditItemStatusLocs>;
export type CPAuditItemStatusEnumLocType = LocMap<CPAuditItemStatusLocs>;

export const spAuditItemStatusKeys: {
	[key in AuditItemStatus]: keyof SPAuditItemStatusEnumLocType;
} = {
	[AuditItemStatus.Invalid]: 'SPAuditItemStatusEnumInvalid',
	[AuditItemStatus.Pending]: 'SPAuditItemStatusEnumPending',
	[AuditItemStatus.Valid]: 'SPAuditItemStatusEnumValid',
};

export const cpAuditItemStatusKeys: {
	[key in AuditItemStatus]: keyof CPAuditItemStatusEnumLocType;
} = {
	[AuditItemStatus.Invalid]: 'CPAuditItemStatusEnumInvalid',
	[AuditItemStatus.Pending]: 'CPAuditItemStatusEnumPending',
	[AuditItemStatus.Valid]: 'CPAuditItemStatusEnumValid',
};
